import React from 'react';
import PropTypes from 'prop-types';

const CostCalculatedFor = ({ data }) => {
  let displayText = "Kröfuhafa";
  if (data === 1)
  {
    displayText = "Lögfræðing";
  }
  return (
    <span>{displayText}</span>
  );
};

CostCalculatedFor.propTypes = {
  data: PropTypes.number,
};

export default CostCalculatedFor;





// WEBPACK FOOTER //
// ./src/pages/Calculation/Display/CostCalculatedFor.js